import React, { Component } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from "react-router";

import Footer from '../layoutItems/footer';
import NavMenu from '../layoutItems/navMenu';
import ToTopButton from '../common/toTopButton';

import '../layoutItems/layout.scss';
import './privateLayoutNew.scss'

class PublicLayout extends Component {
    state = {
        scrollTop: 0,
        isOnReport:false,
        isBegin:true,
        isEnd:false,
        minusWidth:0,
        hasScrollY:false
    }

    render() { 
        const tint = localStorage.locales_tint;
        return (
            <div className='grid-root'>
                <div className={classnames('main-content', { 'scrolled-y': this.state.scrollTop > 0 })}
                    style={{ marginRight: this.state.minusWidth, paddingTop: this.props.user.authentication.limitedUser ? '0px' : null }}>
                    <div className="page-nav print-hidden">
                        <NavMenu componentProps={this.props.componentProps} mobileTinted={tint === 'header'} />
                    </div>
                    {this.renderScrollingContent(tint)}
                </div>
            </div>
        );
    }

    renderScrollingContent = (tint) => {
        const Component = this.props.component;
        return (
            <div className={classnames('content-body-wrapper', { 'content-mobile-search': this.props.layout.topMenuExpanded })}>
                <div className={`content-body ${this.props.pageClass || ''}`}>
                    <div className='page-content'>
                        <Component {...this.props.componentProps} {...this.props.children}></Component>
                    </div>
                    <div className="page-footer">
                        <ToTopButton scrollTop={this.state.scrollTop} isBegin={this.state.isBegin} isEnd={this.state.isEnd} right={this.state.minusWidth} />
                        <Footer public={true} />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    state => { return { ...state.appContext, ...state.report, layout: state.layout }; }
)(withRouter(PublicLayout));